import { useEffect, useRef, type MutableRefObject } from 'react';

/** await の後で、画面を離れた（組織を切り替えた）後の遷移・表示を止めるために使う。 */
export function useMountedRef(): MutableRefObject<boolean> {
  const mountedRef = useRef(false);
  useEffect(() => {
    // StrictMode の再マウントでも true に戻す
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  return mountedRef;
}
